import { Component } from 'react';
import React from 'react';
import ContentWrapper from "../Layout/ContentWrapper";
import { Grid, Row, Col, Panel, Button, ButtonToolbar, Breadcrumb, Modal, FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import genericRadioFilter from '../Common/genericRadioFilter';
import dateFilterRadios from '../Common/dateFilterRadios';
import { connect } from 'react-redux'
import { Toolbar, Data } from 'react-data-grid-addons';
import ReactDataGrid from "react-data-grid";

class MMdriver extends Component {
    constructor(props) {
        super(props)
        this.state = {
            path: "MMdriver",
            value: 'all',
            FromDate: undefined,
            ToDate: undefined,
            days: '7',
            search: '',
            drivers: [],
            filters: {},
            rows: [],
            selectedRows: [],
            show: false,
            is_process: 'no'
        }
    }

    componentDidMount() {
        this.fetchDriverApplication(7);
    }

    componentWillReceiveProps(newProps) {
        const modifiedDrivers = newProps.drivers.map(driver => {
            return {
                ...driver,
                is_process: driver.is_process ? 'Yes' : 'No'
            }
        })
        this.setState({
            rows: modifiedDrivers
        })
    }
    handleStatusFilterChange = (status) => {
        this.setState({
            value: status
        })
    }
    formatDate(date) {
        let formattedDate = `${date.getFullYear()}-`;
        formattedDate += `${date.getMonth() + 1}-`;
        if (date.getDate() < 10) {
            formattedDate += `0${date.getDate()}`;
        } else {
            formattedDate += date.getDate();
        }
        return formattedDate;
    }

    setFromDate = (date) => {
        this.setState({
            FromDate: date
        })
    }

    setToDate = date => {
        this.setState({
            ToDate: date
        })
    }
    fetchDriverApplication = (days) => {
        let FromDate = '1900-01-01';
        let ToDate = '3000-01-01';
        if (this.state.FromDate != null) {
            FromDate = this.formatDate(this.state.FromDate);
        }
        if (this.state.ToDate != null) {
            ToDate = this.formatDate(this.state.ToDate);
        }
        if (days === '-1' || days === -1) {
            this.setState({ days }, () => {
                this.props.fetchMMDriversByTime(FromDate, ToDate)
            })
        } else {
            this.setState({ days: days, FromDate: null, ToDate: null }, () => {
                const fromDate = new Date((new Date()).getTime() - days * 24 * 60 * 60 * 1000);
                this.props.fetchMMDriversByTime(this.formatDate(fromDate), ToDate);
            })
        }
        this.setState({ selectedRows: [{}], days: days });
    }

    renderDriversTable() {
        const booleanFormatter = ({ value }) => {
            return (
                <span>{value ? 'yes' : 'no'}</span>
            )
        }
        const handleGridSort = (sortColumn, sortDirection) => {
            const state = Object.assign({}, this.state, { sortColumn, sortDirection });
            this.setState(state);
        };

        const handleFilterChange = (filter) => {
            // const { rows } = this.state;
            // this.setState({ rows });
            const newFilters = Object.assign({}, this.state.filters);
            if (filter.filterTerm) {
                newFilters[filter.column.key] = filter;
            } else {
                delete newFilters[filter.column.key];
            }
            this.setState({ filters: newFilters });
        };

        const getRows = () => Data.Selectors.getRows(this.state);
        const getSize = () => getRows().length;

        const rowGetter = (rowIdx) => {
            const rows = getRows();
            return rows[rowIdx];
        };

        const onRowClick = (rowIdx, row) => {
            if (rowIdx !== -1) {
                const rows = getRows();
                rows.map((r) => {
                    r.isSelected = false;
                });
                rows[rowIdx].isSelected = true;
                this.setState({ rows, selectedRows: [rows[rowIdx]] });
            }
        };

        const onCellSelected = (coordinates) => {
            const rows = getRows();
            rows.map((r) => {
                r.isSelected = false;
            });
            rows[coordinates.rowIdx].isSelected = true;
            this.setState({ rows, selectedRows: [rows[coordinates.rowIdx]] });
        };

        const onClearFilters = () => {
            this.setState({ filters: {} });
        };
        const onRowsSelected = (rows) => {
            const newRows = getRows();
            const selectedRows = [newRows[rows[0].rowIdx]];
            newRows.map((r) => {
                r.isSelected = false;
            });
            rows.map((r) => {
                newRows[r.rowIdx].isSelected = true;
            });
            this.setState({ rows: newRows, selectedRows, is_process: rows[0]['row']['is_process'] }, () => {
                console.log('you just selected an row', this.state);
            });
        };
        const onRowsDeselected = (rows) => {
            const newRows = [...this.state.rows];
            rows.map((r) => {
                newRows[r.rowIdx].isSelected = false;
            });
            this.setState({ rows: newRows, selectedRows: [] });
        };

        const columns = [
            {
                key: 'first_name',
                name: <Translate value="first_name" />,
                resizable: true,
                sortable: true,
                width: 80,
                filterable: true,
            },
            {
                key: 'last_name',
                name: <Translate value="last_name" />,
                resizable: true,
                sortable: true,
                width: 120,
                filterable: true,
            },
            {
                key: 'is_process',
                name: <Translate value="processed" />,
                // formatter: booleanFormatter,
                resizable: true,
                sortable: true,
                width: 90,
                filterable: true,
            },
            {
                key: 'email',
                name: <Translate value="email" />,
                resizable: true,
                sortable: true,
                width: 100,
                filterable: true,
            },
            {
                key: 'phone_number',
                name: <Translate value="phone_number" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 160,
            },
        ];
        return (
            <Row>
                <Col>
                    <ReactDataGrid
                        // rowKey="RMA_num"
                        enableCellSelect
                        onClearFilters={onClearFilters}
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter />}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowHeight={25}
                        headerRowHeight={45}
                        rowGetter={rowGetter}
                        rowsCount={getSize()}
                        minHeight={270}
                        enableRowSelect="single"
                        // onRowUpdated={this.handleRowUpdated}
                        rowSelection={{
                            showCheckbox: true,
                            onRowsSelected,
                            onRowsDeselected,
                            selectBy: {
                                isSelectedKey: 'isSelected',
                            },
                        }}
                        onRowClick={onRowClick}
                        onCellSelected={onCellSelected}
                    />
                </Col>
            </Row>
        )
    }

    handleDriverEditClick = (e) => {
        this.setState({
            show: true,
        })
    }

    renderModal = () => {
        const handleHide = () => {
            this.setState({ show: false });
        }

        const handleSelectionChange = (e) => {
            this.setState({
                is_process: e.target.value,
            })
        }

        const handleDriverInfoChange = () => {
            const bol = this.state.is_process.toLowerCase();
            const data = {
                ...this.state.selectedRows[0],
                is_process: bol === "no" ? false : true
            }
            this.props.editDriverInfomation(data);
            // this.forceUpdate();
        }
        // const value = this.state.selectedRows[0] ? this.state.selectedRows[0].is_process : 'no'
        return (
            <div className="modal-container-shayne">
                <Modal
                    show={this.state.show}
                    // onHide={handleHide}
                    container={this}
                    aria-labelledby="contained-modal-title"
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title">
                            MyuMyu Driver Application
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <span>Processed:</span>
                            <select value={this.state.is_process} onChange={(e) => handleSelectionChange(e)}>
                                <option value="Yes">Yes</option>
                                <option  value="No">No</option>
                            </select>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={handleHide}>Close</Button>
                        <Button onClick={handleDriverInfoChange}>Confirm</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
    render() {
        return (
            <ContentWrapper >
                <Breadcrumb>
                    <Breadcrumb.Item>
                        <Translate value="rma" />
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active="true">
                        <Translate value={this.state.path === 'MMdriver' ? "MMdriver" : "MMdriver"} />
                    </Breadcrumb.Item>
                </Breadcrumb>
                <Grid id="purchase-order-list">
                    <Panel id="date-range-picker" className="form-horizontal">
                        {/* <Row>
                            <Col xs={3}>
                                <h3 className="filter-title">
                                    <Translate value="DriverApplicationStatus" />
                                    <span className="colon">:</span>
                                </h3>
                            </Col>
                            <Col xs={9}>
                                <div id="statusFilterRadios" className="form-horizontal">
                                    {genericRadioFilter({
                                        content: [
                                            {
                                                option: 'all',
                                                id: 'all-radio-filter',
                                                name: 'statusFilterRadios',
                                                labelName: 'all',
                                            },
                                            {
                                                option: 'unprocessed',
                                                id: 'unprocessed-radio-filter',
                                                name: 'statusFilterRadios',
                                                labelName: 'Unprocessed',
                                            },
                                            {
                                                option: 'processed',
                                                id: 'processed-radio-filter',
                                                name: 'statusFilterRadios',
                                                labelName: 'Processed',
                                            },
                                        ],
                                        value: this.state.value,
                                        handleOnClick: this.handleStatusFilterChange,
                                        type: 'buttons',
                                    })}
                                </div>
                            </Col>
                        </Row> */}
                        <Row>
                            <Col xs={3}>
                                <h3 className="filter-title">
                                    <Translate value="application_date" />
                                    <span className="colon">:</span>
                                </h3>
                            </Col>
                            <Col xs={9}>
                                {dateFilterRadios({
                                    handleOnClick: this.fetchDriverApplication,
                                    setToRangeSearch: () => this.setState({ days: '-1' }),
                                    setFromDate: date => this.setFromDate(date),
                                    setToDate: date => this.setToDate(date),
                                    FromDate: this.state.FromDate,
                                    ToDate: this.state.ToDate,
                                    Days: this.state.days,
                                })}
                            </Col>
                        </Row>
                    </Panel>
                    <Panel className="position-relative table-collapse-fix">
                        <ButtonToolbar className="table-buttons">
                            <Button
                                bsStyle="warning"
                                type="button"
                                onClick={e => this.handleDriverEditClick(e)}
                                disabled={this.state.selectedRows.length === 0}
                            >
                                <em className="fa fa-pencil" />
                                <Translate value="edit" />
                            </Button>
                        </ButtonToolbar>
                        {this.renderDriversTable()}
                    </Panel>
                </Grid>
                {this.renderModal()}
            </ContentWrapper>
        );
    }
}

export default MMdriver;



// WEBPACK FOOTER //
// ./master/jsx/components/MMdriver/index.jsx